<div class="symmetry-game" [class.is-immersive]="isFullscreen" *ngIf="shape">

  <!-- Prompt bar -->
  <div class="prompt-bar">
    <div class="prompt-main">
      <span class="prompt-icon" aria-hidden="true">🔷</span>
      <span class="prompt-text">
        {{ currLang === 'ar' ? 'اسحب المرآة لتجد خط التماثل' : 'Slide the mirror to find a line of symmetry' }}
      </span>
    </div>
    <div class="prompt-chips">
      <span class="chip chip-shape">{{ shapeName }}</span>
      <span class="chip chip-axes">{{ axisHintLabel }}</span>
    </div>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots" [attr.aria-label]="(currLang === 'ar' ? 'الجولة' : 'Round') + ' ' + (currentRound + 1) + '/' + totalRounds">
    <span class="dot"
          *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]"
          [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-symmetry-stage
      [shape]="shape"
      [roundKey]="currentRound"
      [hintVisible]="hintVisible"
      [interactive]="!resolving"
      (solved)="onSolved()"
      (missed)="onMissed()">
    </app-symmetry-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn hint-btn" *ngIf="canUseHint" (click)="useHint()">
      <span aria-hidden="true">💡</span>
      {{ currLang === 'ar' ? 'تلميح' : 'Hint' }}
    </button>
    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <!-- Success burst -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <div class="success-icon" aria-hidden="true">✨</div>
      <div class="success-title">{{ currLang === 'ar' ? 'تماثل تام!' : 'Perfect Symmetry!' }}</div>
      <div class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</div>
    </div>
  </div>

  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
